import { NavLink, useNavigate } from 'react-router-dom';
import { ClipboardCheck, MailX, MessageSquare, ListChecks, MessageSquarePlus } from 'lucide-react';
import { useState } from 'react';
import { useTranslations } from 'use-intl';
import { cn } from '@/lib/utils';
import HarmonyLogo from '@/components/branding/HarmonyLogo';
import { FeedbackPanel } from '@/components/feedback/FeedbackPanel';
import { UserMenu } from './UserMenu';

const PlatformAdminSidebar = () => {
  const t = useTranslations('consultantShell.nav');
  const navigate = useNavigate();
  const [feedbackOpen, setFeedbackOpen] = useState(false);

  return (
    <div className="h-screen w-64 flex-shrink-0 bg-background border-r fixed left-0 z-50 flex flex-col">
      <div className="flex items-center h-16 px-4 border-b">
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => navigate('/')}>
          <HarmonyLogo size="md" showText={true} />
        </div>
      </div>

      <div className="px-3 py-2">
        <p className="text-xs font-medium text-muted-foreground uppercase tracking-wider px-2 py-1">
          {t('platformAdminView')}
        </p>
      </div>

      <nav className="p-2 flex-grow">
        <ul className="space-y-1">
          <li>
            <NavLink
              to="/review"
              className={({ isActive }) =>
                cn('sidebar-link', isActive && 'sidebar-link-active')
              }
            >
              <ClipboardCheck size={20} />
              <span>{t('review')}</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/todos"
              className={({ isActive }) =>
                cn('sidebar-link', isActive && 'sidebar-link-active')
              }
            >
              <ListChecks size={20} />
              <span>{t('todos')}</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/unmatched-emails"
              className={({ isActive }) =>
                cn('sidebar-link', isActive && 'sidebar-link-active')
              }
            >
              <MailX size={20} />
              <span>{t('unmatchedEmails')}</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/messages"
              className={({ isActive }) =>
                cn('sidebar-link', isActive && 'sidebar-link-active')
              }
            >
              <MessageSquare size={20} />
              <span>{t('messages')}</span>
            </NavLink>
          </li>
        </ul>
      </nav>

      {/* This layout has no top bar, so the user menu (Change company, sign out) lives here. */}
      <div className="p-2 border-t">
        <UserMenu variant="sidebar" />
      </div>

      {/* Feedback entry (in-app-feedback F2/EC8/AC1) — footer slot above the account area
          (Draft A, screens.md S3). A platform admin submits with company_id = null (EC8). */}
      <div className="p-2 border-t">
        <button
          className={cn('sidebar-link w-full')}
          onClick={() => setFeedbackOpen(true)}
        >
          <MessageSquarePlus size={20} />
          <span>{t('feedback')}</span>
        </button>
      </div>

      <FeedbackPanel open={feedbackOpen} onOpenChange={setFeedbackOpen} />
    </div>
  );
};

export default PlatformAdminSidebar;
